import styles from './TermsModal.module.css'
import { ReactComponent as Logo } from '../../../assets/Logo.svg'
import Button from '../../../common/components/Button'
import Layout from '../../../common/components/Layout'
import { t } from 'i18next'

interface TermsModalProps {
  onAccept: () => void
  onClose: () => void
}

const TermsModal = ({ onAccept, onClose }: TermsModalProps) => (
  <div className={styles.modalContainer}>
    <Layout hasBackButton backButtonAction={onClose}>
      <div className={styles.logoWrapper}>
        <Logo />
      </div>
      <div className={styles.contentWrapper}>
        <h2>{t('terms.title')}</h2>
        <p className={styles.date}>{t('terms.header')}</p>
        <div className={styles.terms}>
          {t('terms.text')
            .split('\n')
            .map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
        </div>
        <Button
          title={t('terms.accept')}
          backgroundColor="black"
          onClick={onAccept}
        />
      </div>
    </Layout>
  </div>
)

export default TermsModal
